import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountContact, ErrorReportingService, FullPageMaskService } from 'common';
import { Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { ContactService } from '../../../../services/contact.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'acc-contact-remove',
  templateUrl: './contact-remove.component.html',
  styleUrls: ['./contact-remove.component.scss'],
})
export class ContactRemoveComponent implements OnInit {
  private _destroy$ = new Subject<void>();
  private defaultErrorMessage: string = 'There was a problem processing your request.';
  contactList: { email: string; id: number }[];
  email: string;
  hasActiveLicence: boolean;
  lcAuto: number;
  isError = false;
  errorMessages = [];
  contactSelectionFormGroup = new FormGroup({
    selectedContact: new FormControl('', Validators.required),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private errorService: ErrorReportingService,
    private contactService: ContactService,
    private maskService: FullPageMaskService
  ) {}

  ngOnInit(): void {
    this.route.paramMap
      .pipe(
        takeUntil(this._destroy$),
        map(() => window.history.state)
      )
      .subscribe((state: { contactList: AccountContact[]; contact: AccountContact }) => {
        const selectedContact: AccountContact = state.contact;
        if (state.contactList == null || selectedContact == null) {
          this.cancel();
        } else {
          this.lcAuto = +selectedContact.lcAuto;
          this.hasActiveLicence = selectedContact.hasActiveLicences;
          this.email = selectedContact.email;
          if (this.hasActiveLicence) {
            this.contactList = state.contactList
              .filter((contact: AccountContact) => contact.lcAuto !== this.lcAuto)
              .map((contact: AccountContact) => ({ email: contact.email, id: contact.lcAuto }));
          } else this.contactSelectionFormGroup.disable();
        }
      });
  }

  cancel() {
    this.router.navigate(["accounts/details/contacts"]);
  }

  removeContact() {
    if (this.contactSelectionFormGroup.invalid) return;
    this.isError = false;
    this.maskService.showLoading();
    try {
      this.contactService
        .removeContact(this.lcAuto, +this.contactSelectionFormGroup.controls.selectedContact.value)
        .pipe(takeUntil(this._destroy$))
        .subscribe({
          next: (validationErrors: number[]) => {
            this.isError = validationErrors.length > 0;
            if (!this.isError) {
              this.showStatus();
            }
            else if(this.email === this.contactService.getCurrentUsername())this.showError(['User cannot remove themselves.']);
            else this.showError([this.defaultErrorMessage]);
          },
          error: (response) => {
            this.isError = true;
            this.showError(this.errorService.getResponseDTOErrors(response));
          },
        });
    } catch (error) {
      this.isError = true;
    }
  }

  private showError(errorMessages: string[]): void{
    this.errorMessages = errorMessages; 
    this.errorService.displayWarning(this.defaultErrorMessage);
    this.maskService.hideLoading();
  }

 private  showStatus(): void {
    this.errorService.displayInfo(
      this.hasActiveLicence
        ? 'The removal request has been noted. A member of the licensing team will be in touch.'
        : 'The contact was removed successfully'
    );
    this.router.navigateByUrl('/accounts/details/contacts');
  }
}
